import { WsReactBaseComponentInterface, WsReactBaseContainer } from '@thewhite/react-base-components';
import { FlexBox } from '@thewhite/react-flex-layout';
import { GlobalStore } from '@thewhite/react-global-module/lib/store';
import classnames from 'classnames';
import isEqual from 'lodash.isequal';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import ReactSVG from 'react-svg';
import { ToastContainer, ToastPosition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthService } from '../../Auth/services/authServices';
import { MainMenu } from '../../Global/components/mainMenu/mainMenu';
import Preloader from '../../Global/components/preloader/preloader';
import { RefStore } from '../../Global/store/refStore';
import * as authActions from '../../Auth/actions/authActions';

interface MainWrapProps {
    children: any;
    globalStore?: GlobalStore;
    location: any;
    refStore?: RefStore;
}

interface MainWrapState {
    dataIsLoaded: boolean;
}

interface MainWrapInterface extends WsReactBaseComponentInterface {
    props: MainWrapProps;
    state: MainWrapState;

    startRedirect: boolean;
    appMainContentRef: React.RefObject<HTMLDivElement>;
}

@inject('globalStore', 'refStore')
@observer
export class MainWrap extends WsReactBaseContainer<MainWrapProps, MainWrapState> implements MainWrapInterface {
    appMainContentRef: React.RefObject<HTMLDivElement> = React.createRef();
    startRedirect: boolean = false;

    state: MainWrapState = {
        dataIsLoaded: false,
    };

    constructor(props: MainWrapProps) {
        super(props);
        if (this.props.globalStore) {
            this.props.globalStore.handlerPressControl();
        }
    }

    componentDidMount() {
        if (this.props.globalStore) {
            this.props.globalStore.setLocation(this.props.location);
        }
        if (this.appMainContentRef && this.appMainContentRef.current) {
            this.props.refStore?.setMainContentRef(this.appMainContentRef);
        }

        if (!AuthService.getUserInfo()) {
            authActions.whoami()
                .finally(this.checkAuth)
        } else {
            this.checkAuth();
        }
    }

    componentWillReceiveProps(newProps: MainWrapProps) {
        if (!isEqual(newProps.location, this.props.location) && !!this.props.globalStore) {
            this.props.globalStore.setLocation(newProps.location);
        }
    }

    /**
     * Проверка авторизации
     */
    checkAuth = (): void => {
        const userInfo = AuthService.getUserInfo();
        if (!userInfo) AuthService.logOut();
        else this.setState({ dataIsLoaded: true });
    }

    /**
     * Получить строку со значением текущего года
     */
    getCurrentYear = (): string => {
        return this.moment()
            .year()
            .toString();
    }

    render(): false | JSX.Element {
        if (!!this.props.globalStore && !!this.props.globalStore.redirect && !this.startRedirect) {
            this.startRedirect = true;
        } else if (this.startRedirect && !!this.props.globalStore) {
            this.startRedirect = false;
            this.props.globalStore.clearRedirect();
        }

        return (
            <>
                {
                    this.state.dataIsLoaded &&
                    <>
                        {
                            !!this.props.globalStore && !!this.props.globalStore.redirect && this.startRedirect &&
                            <Redirect
                                to={this.props.globalStore.redirect}
                                push={true}
                            />
                        }
                        <FlexBox
                            className={classnames(
                                'main-wrap',
                            )}
                            row={'start stretch'}
                        >
                            <div
                                className={'main-wrap__content-box'}
                            >
                                <main
                                    className={classnames(
                                        'main-wrap__main-content',
                                        'app-main',
                                    )}
                                    ref={this.appMainContentRef}
                                >
                                    {
                                        this.props.globalStore && this.props.globalStore.loading &&
                                        <Preloader/>
                                    }
                                    {
                                        !!this.props.globalStore && !!this.props.globalStore.redirect && this.startRedirect
                                            ?
                                            <Redirect
                                                to={this.props.globalStore.redirect}
                                                push={true}
                                            />
                                            :
                                            this.props.children
                                    }
                                </main>
                                <footer
                                    className={classnames(
                                        'main-wrap__content-footer',
                                        'app-footer',
                                    )}
                                >
                                    <p
                                        className={classnames(
                                            'app-footer__footer-copyright',
                                            'text-body-1',
                                        )}
                                    >
                                        Министерство цифрового развития Камчатского края
                                    </p>
                                    <FlexBox
                                        <HTMLAnchorElement>
                                        node={'a'}
                                        row={'ctr'}
                                        className={'app-footer__footer-created-by-link'}
                                        href={'https://thewhite.ru/'}
                                        target={'_blank'}
                                        rel={'noopener noreferrer'}
                                    >
                                        <ReactSVG
                                            className={'app-footer__footer-created-by-link-icon-wrapper'}
                                            src={'assets/images/svg/white.svg'}
                                            svgClassName={'app-footer__footer-created-by-link-icon'}
                                        />
                                    </FlexBox>
                                </footer>
                            </div>
                            <FlexBox
                                shrink={'0'}
                                node={'aside'}
                                column={'start stretch'}
                                className={classnames(
                                    'main-wrap__sidebar',
                                    'app-sidebar',
                                )}
                            >
                                <a
                                    href={'#/'}
                                    className={classnames(
                                        'main-wrap__sidebar-home-link',
                                    )}
                                >
                                    <ReactSVG
                                        className={classnames(
                                            'main-wrap__sidebar-home-link-icon-wrapper',
                                        )}
                                        src={'assets/images/svg/logo/kam-logo.svg'}
                                        svgClassName={'main-wrap__sidebar-home-link-icon'}
                                    />
                                </a>
                                <MainMenu
                                    pathName={this.props.location.pathname}
                                />
                            </FlexBox>
                            <ToastContainer
                                toastClassName="global-toast"
                                position={ToastPosition.BOTTOM_RIGHT}
                            />
                        </FlexBox>
                    </>
                }
            </>
        );
    }
}

export default MainWrap;
